import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  transform(value: string): string {
    const element = document.createElement('DIV');
    element.innerHTML = value;
    return element.textContent || element.innerText || '';
  }

}
